import React from 'react';

import { number } from 'prop-types';

import classes from './TabComponent.module.css';

const TabComponent = ({
    index,
    value,
    children,
    ...props
}) => {

    return (
        <div
            className={classes.TabComponent}
            role="tab"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
        >
            {children}
        </div>
    );
};

TabComponent.defaultProps = {
    index: 0,
    value: 0
};

TabComponent.propTypes = {
    index: number,
    value: number
};

export default TabComponent;
